import React from 'react';
import logoBDU from '../../assets/logo_bdu.png';
import logoOrange from '../../assets/logo_orange.png';
import rcLogo from '../../assets/rightcom.png';
import homeIcon from '../../assets/icons/home.png';
import './index.css';
import { useNavigate } from "react-router-dom";

const isOrangeHost = () => window.location.hostname.toLowerCase().includes('orange');

export default function Header(props) {
  const { isHome } = props;
  const history = useNavigate();
  const goHome = () => {
    history('/');
  };

  const resolveLogo = () => {
    if (isOrangeHost() || props.company === 'orange-rdc') return logoOrange;
    if (props.company === 'bdu') return logoBDU;
    if (props.company === 'rightcom') return rcLogo;
    return null;
  };

  const logoSrc = resolveLogo();

  return (
    <div>
      <div className="right-bdu-head-wrap">
        <div className="right-bdu-head-container">
          {!isHome && (
            <div onClick={() => goHome()} className="right-bdu-head-back-home-container">
              <img src={homeIcon} alt="icon-home"/>
            </div>
          )}
          <div className={'name-container'}>
            {logoSrc
              ? <img className="logo" src={logoSrc} alt="logo" style={props.company === 'rightcom' ? { height: 40 } : undefined}/>
              : <h2>{props.companyData?.name}</h2>
            }
          </div>
        </div>
      </div>
    </div>
  );
}
